import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

const usePosition = () => {
    const callApi = useCallApi()
    const [position, setPosition] = useState([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet<any>({
                url: umServinceURL.getLookupPosition,
            })
            setPosition(data.result)
        } catch (error) {
            console.log('error', error)
        }
    }

    return { position }
}

export default usePosition
